// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "loginweb/static/styles/" + "mntv-app-loginweb" + "." + "d012a50e" + ".css";
};